import '../SectionMainAdvantages/section-main-advantages.css';
import Title from '../../@common.blocks/Title/index';
import Container from '../../@common.blocks/Container';
import DostavkaBajkal from '../../pictures/байкал сервис.jpeg';
import DostavkaDelovyeLin from '../../pictures/deliver-delline.png';
import DostavkaPek from '../../pictures/пэкк.png';
import DostavkaAvto from '../../pictures/автотрейдинг.jpeg';
import DostavkaZhelDor from '../../pictures/желдорэкспедиция.png';
import DostavkaCdek from '../../pictures/deliver_cdek.png';
import Button from '../../@common.blocks/Button/index';
import { HashLink } from 'react-router-hash-link/dist/react-router-hash-link.cjs.development';

const SectionMainAdvantages = () => {
  return (
    <div className="section-main-advantages">
      <Container>
        <div>
          <div className="section-main-advantages__delivery">
            <div className="section-main-advantages__delivery-contant">
              <Title level="2" size="md">
                Транспортные компании
              </Title>
              <div className="section-main-advantages__delivery-logo">
                <img src={DostavkaBajkal} alt="" />
                <img src={DostavkaPek} alt="" />

                <img src={DostavkaAvto} alt="" />
                <img src={DostavkaDelovyeLin} alt="" />

                <img src={DostavkaZhelDor} alt="" />
                <img src={DostavkaCdek} alt="" />
              </div>
              <Title level="3" size="md">
                Всегда на связи
              </Title>
              <p>
                Мы доставим Ваше оборудование по всей России и ближнему
                зарубежью. Ваш заказ будет доставлен без повреждений и вовремя.
              </p>
              <HashLink to="/fill_the_form">
                <Button color="orange">Оформить</Button>/
              </HashLink>
            </div>
          </div>
          <div className="section-main-advantages__list">
            <Title level="2" size="md">
              Наши преимущества
            </Title>
            <p>
              Качественная продукция и неотъемлемая проверка изготавливаемой
              продукции перед отправкой заказчику. Надежность и безотказность
              работы вашего оборудования — это качественно выполненный монтаж и
              наладка.
            </p>
            <p>
              Выполняемые проектирование, сборка, монтаж и наладка выпускаемого
              оборудования всегда в кротчайшие сроки и без задержек. Мы всегда
              стремимся найти поставщиков с самым коротким сроком поставки
              комплектующих.
            </p>
            <p>
              Индивидуальный подход к каждому заказчику и каждому проекту. Мы
              стремимся всегда выполнить работы со всеми требованиями от
              заказчика в полном соответствии с заданием.
            </p>
            <p>
              Полный комплект документации с каждым выполненным изделием или
              выполненной услугой. Всё электрощитовое оборудование имеет
              соответствующий паспорт качества.
            </p>
            <p>
              Профессиональная консультация по подбору и обслуживанию
              изготавливаемого оборудования на всех этапах сотрудничества.
              Сервисное обслуживание оборудования весь гарантийный срок.
            </p>
          </div>
        </div>
      </Container>
    </div>
  );
};
export default SectionMainAdvantages;
